export function formatDate(dateString) {
  const date = new Date(dateString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return "";
  }

  // Define formatting options for the date and time
  const weekdayOptions = { weekday: "short" };
  const monthDayOptions = { month: "short", day: "numeric" };
  const timeOptions = { hour: "numeric", minute: "numeric", hour12: true };

  // Format the components
  const weekday = new Intl.DateTimeFormat("en-US", weekdayOptions).format(date);
  const monthDay = new Intl.DateTimeFormat("en-US", monthDayOptions).format(
    date
  );
  const time = new Intl.DateTimeFormat("en-US", timeOptions).format(date);

  // Combine formatted components
  return `${weekday}, ${monthDay} at ${time}`;
}
